import { render, staticRenderFns } from "./ActiveScheme.vue?vue&type=template&id=4f2af066&scoped=true&"
import script from "./ActiveScheme.vue?vue&type=script&lang=js&"
export * from "./ActiveScheme.vue?vue&type=script&lang=js&"
import style0 from "./ActiveScheme.vue?vue&type=style&index=0&id=4f2af066&prod&lang=scss&scoped=true&"
import style1 from "./ActiveScheme.vue?vue&type=style&index=1&id=4f2af066&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2af066",
  null
  
)

export default component.exports